// src/components/TopMenuBar.jsx
import React, { useContext, useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import './TopMenuBar.css';
import './SmartControl.css';  // contains dropdown styling
import { AuthContext } from '../user/AuthContext';

export default function TopMenuBar({
  onOpenPopup,
  gestureEnabled,      // if you still use this elsewhere
  onToggleGesture,     // likewise
  voiceEnabled,        // optional upstream props
  onToggleVoice
}) {
  const { user, logout } = useContext(AuthContext);
  const nav = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [gest, setGest] = useState(false);
  const [voice, setVoice] = useState(false);
  const panelRef = useRef();

  // close on outside click or ESC
  useEffect(() => {
    const handler = e => {
      if (
        e.key === 'Escape' ||
        (e.type === 'mousedown' &&
          panelRef.current &&
          !panelRef.current.contains(e.target) &&
          !e.target.closest('.gesture-toggle-wrapper'))
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', handler);
    };
  }, []);

  const handleLogout = () => {
    logout();
    nav('/');
  };

  // avatar
  let Avatar;
  if (user?.photoURL) {
    Avatar = <img src={user.photoURL} className="profile-avatar-img" alt="avatar" />;
  } else {
    const IconComp = FaIcons[user?.iconName] || FaIcons.FaUserCircle;
    Avatar = <IconComp size={24} className="profile-icon" />;
  }

  return (
    <>
      <div className="menuBar">
        <div className="left-menu">
          <Link to="/" className="logo">LEXTRACK AI</Link>
        </div>
        <div className="menuItems">
          {/* Smart Control toggle */}
          <div className="gesture-toggle-wrapper">
            <label className="gesture-switch">
              <input
                type="checkbox"
                checked={showDropdown}
                onChange={e => setShowDropdown(e.target.checked)}
              />
              <span className="slider" />
            </label>
            <span className="label-text">Smart Control</span>
          </div>

          <Link to="/our-company" className="link">Our Company</Link>
          <Link to="/app" className="link">App Store</Link>

          {!user ? (
            <Link to="/login" className="link">Login</Link>
          ) : (
            <>
              <span
                className="profile-icon-wrapper"
                onClick={() => nav('/profile')}
                style={{ cursor: 'pointer', marginLeft: '20px' }}
              >
                {Avatar}
              </span>
              <button onClick={handleLogout} className="logout-button" style={{ marginLeft: '10px' }}>
                Log out
              </button>
            </>
          )}
        </div>
      </div>

      {/* Inlined Smart Control dropdown */}
      {showDropdown && (
        <div ref={panelRef} className="feature-panel">
          <h3 className="panel-title">Smart Control</h3>
          <label className="feature-row">
            <input
              type="checkbox"
              checked={gest}
              onChange={e => {
                setGest(e.target.checked);
                onToggleGesture && onToggleGesture(e.target.checked);
              }}
            />
            Hands Gesture Control
          </label>
          <label className="feature-row">
            <input
              type="checkbox"
              checked={voice}
              onChange={e => {
                setVoice(e.target.checked);
                onToggleVoice && onToggleVoice(e.target.checked);
              }}
            />
            Voice Dictation
          </label>
        </div>
      )}
    </>
  );
}
